import { Component } from 'react';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error('App crashed:', error, info);
  }

  handleReload = () => {
    this.setState({ hasError: false, error: null });
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      const msg = this.state.error?.message || String(this.state.error || '');
      return (
        <div
          data-testid="app-error-boundary"
          style={{
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '24px',
            background: '#ffffff',
            color: '#111827',
            fontFamily: 'sans-serif',
            textAlign: 'center',
          }}
        >
          <div style={{ maxWidth: 420 }}>
            <div style={{ fontSize: 40, marginBottom: 12 }}>⚠️</div>
            <h1 style={{ fontSize: 20, fontWeight: 700, margin: '0 0 8px' }}>
              画面の表示中に問題が発生しました
            </h1>
            <p style={{ fontSize: 14, color: '#6b7280', margin: '0 0 20px', lineHeight: 1.6 }}>
              お手数ですが、下のボタンから再読み込みしてください。
              解決しない場合は、しばらく時間をおいて再度お試しください。
            </p>
            <button
              data-testid="error-reload-button"
              onClick={this.handleReload}
              style={{
                background: '#00A651',
                color: '#fff',
                border: 'none',
                borderRadius: 9999,
                padding: '12px 28px',
                fontSize: 15,
                fontWeight: 600,
                cursor: 'pointer',
              }}
            >
              再読み込み
            </button>
            {msg ? (
              <pre
                style={{
                  marginTop: 20,
                  fontSize: 11,
                  color: '#9ca3af',
                  whiteSpace: 'pre-wrap',
                  wordBreak: 'break-word',
                }}
              >
                {msg}
              </pre>
            ) : null}
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
